import { render, staticRenderFns } from "./SelectColumnComponent.vue?vue&type=template&id=2fe8f59b&"
import script from "./SelectColumnComponent.vue?vue&type=script&lang=js&"
export * from "./SelectColumnComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports